enum NotificationStatuses {
	INACTIVE = 0,
	CREATION_IN_PROGRESS = 1,
	SAVING_IN_PROGRESS = 2,
	CREATION_ERROR = 3,
	SAVING_ERROR = 4,
	CREATION_SUCCESS = 5,
	SAVING_SUCCESS = 6
}

export { NotificationStatuses };
